// extracted by mini-css-extract-plugin
module.exports = {"form":"SSOForm_form__9uhVL","link":"SSOForm_link__1OWEg","background":"SSOForm_background__3lMYF","footer":"SSOForm_footer__3RM75"};